var React = require('react');

function CircleGroup (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.2731 24.1328C42.0215 7.23292 70.1644 7.51577 87.5592 24.9106C105.025 42.3761 105.237 70.4483 88.337 88.1966L96.6102 96.4698C118.036 74.1959 117.753 38.6992 95.7616 16.7082C73.7706 -5.28286 38.2739 -5.5657 16 15.8596L24.2731 24.1328Z","fill":"white","fillOpacity":"0.07","key":0}),React.createElement("path",{"d":"M34.8101 77.6612C46.6821 89.5332 65.9303 89.5332 77.8022 77.6612C89.6741 65.7893 89.6741 46.5411 77.8022 34.6691C65.9303 22.7972 46.6821 22.7972 34.8101 34.6691C22.9382 46.5411 22.9382 65.7893 34.8101 77.6612Z","fill":"white","fillOpacity":"0.07","key":1})]);
}

CircleGroup.defaultProps = {"width":"113","height":"113","viewBox":"0 0 113 113","fill":"none"};

module.exports = CircleGroup;

CircleGroup.default = CircleGroup;
